@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="container-fluid p-3 mb-5" *ngIf="guest">
        <div class="w-fit">
            <app-back-button routerLink="/guests" component="Guests"></app-back-button>
        </div>
        <div class="mt-3 d-flex">
            <h1>{{guest.first_name}} {{guest.last_name}}</h1>
        </div>
        @if (this.guest.organization_id) {
            <div class="my-2">
                <app-verification-details [guestDetails]="guest" [availableCheckTypes]="verificationPackageCheckTypes" (refreshGuestDetails)="refreshGuestDetails()"></app-verification-details>
            </div>
            <div class="my-2" *ngIf="shouldDisplayVerificationEmailCard">
                <app-guest-detail-verification-email [guestId]="guest.guest_id" [reservation]="this.reservation"></app-guest-detail-verification-email>
            </div>
            <div class="my-2" *ngIf="userContextProvider.isNaUser()">
                <app-detail-info-card [data]="guestDetails" [title]="'Guest Details'"></app-detail-info-card>
            </div>
            <div class="mb-5" *ngIf="shouldDisplayReservationDetailCard">
                <app-detail-info-card [data]="reservationDetails" [title]="'Reservation Details'"></app-detail-info-card>
            </div>
        }
    </div>
}